import { Component, OnInit, OnDestroy, Input } from "@angular/core";

import { AlertService, MessageSeverity } from '../../services/alert.service';
import { ErrorHandleService } from '../../services/error-handle.service';
import { AuthService } from "../../services/auth.service";
import { Utilities } from '../../services/utilities';
import { UserLogin } from '../../models/user-login.model';

@Component({
  selector: "app-login",
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

// タイムアウトのためOnDestroyを実装
export class LoginComponent implements OnInit, OnDestroy {

  userLogin = new UserLogin();
  isLoading = false;
  formResetToggle = true;
  loginStatusSubscription: any;

  constructor(private alertService: AlertService, private errorHandleService: ErrorHandleService,
    private authService: AuthService) { }

  ngOnInit() {

    // 未ログイン・セッションタイムアウトでリダイレクト
    if (this.getShouldRedirect()) {
      this.authService.redirectLoginUser();
    }
    else {
      this.loginStatusSubscription = this.authService.getLoginStatusEvent().subscribe(isLoggedIn => {
        if (this.getShouldRedirect()) {
          this.authService.redirectLoginUser();
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.loginStatusSubscription)
      this.loginStatusSubscription.unsubscribe();
  }

  getShouldRedirect(): boolean {
    return this.authService.isLoggedIn && !this.authService.isSessionExpired;
  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  login() {
    this.alertService.resetStickyMessage();
    this.isLoading = true;
    this.alertService.startLoadingMessage("", "ログイン試行中...");

    this.authService.login(this.userLogin.userid, this.userLogin.password)
      .subscribe(
      subscription => {
        setTimeout(() => {
          this.alertService.stopLoadingMessage();
          this.isLoading = false;
          this.reset();
        }, 500);
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.errorHandleService.showMessageAndRedirect(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, error);
          }
          else {
            let errorMessage = Utilities.findHttpResponseMessage("error_description", error);

            if (errorMessage) {
              this.errorHandleService.showMessageAndRedirect("ログイン失敗", errorMessage, error);
            }
            else {
              errorMessage = Utilities.findHttpResponseMessage("error", error);
              if (errorMessage == "invalid_grant")
                this.alertService.showStickyMessage("ログイン失敗", "ユーザーIDまたはパスワードを確認してください。", MessageSeverity.error, error);
              else
                this.errorHandleService.showMessageAndRedirect("ログイン失敗", "ログイン中にエラーが発生しました。", error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
}
